'use client';

import React from 'react';
import samplesModel from '@/components/Samples/SamplesModel';
import { rightLanguage } from '@/sharedTypes/helpers';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { GetManagerEntity, ManagerEntity } from '@/shared/globalFunctions';

function SampleInfo() {
  useTranslation();

  // Store values locally to prevent re-computation during render
  const titleText = rightLanguage(samplesModel.sampleInfo.title);
  const authorText = rightLanguage(samplesModel.sampleInfo.author);

  // Only restore from backup once per render cycle using useEffect
  React.useEffect(() => {
    if (!titleText && !authorText && samplesModel._sampleInfoBackup) {
      samplesModel.restoreFromBackup();
    }
  }, [titleText, authorText]);

  // Music sheet was moved after we set title and author, we should sync cursor to it's position
  ManagerEntity?.renderer?.moveCursor();

  return (
    <div className='times-new-roman w-full max-w-[1470px] self-center'>
      <div className='relative width-full flex flex-col items-center justify-between px-3 sm:px-5 lg:px-8 max-lg:landscape:px-5 pt-3.5 md:pt-8 max-lg:landscape:pt-3'>
        <h1 className='text-xl md:text-3xl lg:text-4xl 2xl:text-5xl max-lg:landscape:text-2xl font-medium text-center capitalize'>
          {titleText}
        </h1>
        <h2 className='text-sm md:text-xl 2xl:text-2xl max-lg:landscape:text-base font-medium self-end capitalize'>
          {authorText}
        </h2>
      </div>
    </div>
  );
}

export default observer(SampleInfo);
